import { getRedirectUrl } from '@amzn/d2c-application-website-common';
import { Paths } from 'src/paths/Paths';
import { getStage } from 'src/utils/roadieHelper';

export { TEST_CLIENT_ID, POP_UP_WIDTH_AND_HEIGHT } from '@amzn/d2c-application-website-common';

export const getRedirectUrlForCurrentStage = (): string => {
  return getRedirectUrl(getStage(), Paths.closeWindow);
};
